import Echo from 'laravel-echo';
import { i18n } from '@/i18n';
import { useUserStore } from '@/Stores/user';
import { useNotificationsStore } from '@/Stores/notifications';
import { useCategoriesStore } from '@/Stores/categories';
import { showSuccess } from '@/Mixins/HelperFunctions';

window.Pusher = require('pusher-js');

let echoServer = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
});

export function registerUserPrivateChannels() {
    const user = useUserStore().user;

    echoServer.private(`App.Models.User.${user?.id}`).listen('Notifications.Secret.SendNotificationToUser', (e) => {
        showSuccess(i18n.t('toasts.newNotification'));
        useNotificationsStore().add(e.notification);
    });

    // Permission gated notifications:
    if (useUserStore().hasPermissionTo('Receive administrator live notifications')) {
        echoServer.private('administrators').listen('Notifications.Secret.SendNotificationToAdmins', (e) => {
            showSuccess(i18n.t('toasts.newNotification'));
            useNotificationsStore().add(e.notification);
        });
    }

    // Update corporate links
    echoServer.private('update-corporate-links').listen('Notifications.Secret.SendNotificationToAllUsers', (e) => {
        useCategoriesStore().updateCorporateLinks(e);
    });

    // Update campaigns information sidebar button visibility
    echoServer.private('update-campaigns-pdf-url').listen('Notifications.Secret.SendNotificationToAllUsers', (e) => {
        useCategoriesStore().updateCampaignsPdfUrl(e.data[0]);
    });

    echoServer.private('product-stocks').listen('SendProductStocksEvent', (data) => {
        window.EventBus.$emit('updated-product-stocks', { data: data.data });
    });
}

export function unregisterUserPrivateChannels(userId, branchId, sellerId = null) {
    echoServer.leave(`App.Models.User.${userId}`);
    echoServer.leave('update-corporate-links');
    echoServer.leave('update-campaigns-pdf-url');
    echoServer.leave('product-stocks');

    if (useUserStore().hasPermissionTo('Receive administrator live notifications')) {
        echoServer.leave('administrators');
    }

    // Unsub from shared carts
    if (branchId && !sellerId) {
        echoServer.leave(`App.Models.Branch.${branchId}.Cart`);
    }
}

export function unsubscribeFromSharedCart(branchId, sellerId=null) {
    if (branchId && !sellerId) {
        echoServer.leave(`App.Models.Branch.${branchId}.Cart`);
    }
}

export function subscribeToSharedCart(branchId, prevBranchId, userId, sellerId = null) {
    // If the sellerId is defined, we don't want to listen any update shared cart notifications
    if (!sellerId) {
        // If there was another branch before, unsubscribe from its feed
        if (prevBranchId) {
            echoServer.leave(`App.Models.Branch.${prevBranchId}.Cart`);
        }

        echoServer.private(`App.Models.Branch.${branchId}.Cart`).listen('Notifications.Secret.UpdateSharedCart', (data) => {
            let wasDeleted = data.data[0];
            let serverUserId = data.data[1];

            if (serverUserId !== userId) {
                if (wasDeleted) {
                    showSuccess(i18n.t('toasts.cartEmptiedByOther'));
                } else {
                    showSuccess(i18n.t('toasts.cartUpdatedByOther'));
                }

                window.EventBus.$emit('new-shared-cart', { data: data.data, branchId });
            }
        });
    }
}
